// src/stone/illustrations/MailSuccessesIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MailSuccessesIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#mail-successes_Illustration_svg__a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#008E5A",
            d: "M48 17.349 25.287.422a2.17 2.17 0 0 0-2.573 0L0 17.35v16.258h48z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M48 23.855 0 24.17l6.87-6.822h35.866z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M45.7 19.719a.16.16 0 0 1-.096-.032l-2.92-2.19H6.92l-2.91 1.881a.16.16 0 0 1-.216-.038.14.14 0 0 1 .04-.205l2.95-1.906a.16.16 0 0 1 .088-.026H42.74c.035 0 .07.01.096.032l2.963 2.222c.068.05.08.144.025.208a.16.16 0 0 1-.122.054"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M42.737 2.129H6.87v44.043h35.866z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#00A868",
            d: "m42.737 43.615-15.99-13.317c-1.57-1.309-3.924-1.309-5.494 0L5.263 43.615"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M48 48H0V17.347l23.64 16.258L48 17.348z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M5.265 43.763a.16.16 0 0 1-.116-.05.14.14 0 0 1 .012-.208L20.506 30.51a.16.16 0 0 1 .22.012.14.14 0 0 1-.012.209L5.37 43.726a.16.16 0 0 1-.104.037M42.737 43.763a.16.16 0 0 1-.104-.038L27.505 30.93a.14.14 0 0 1-.012-.209.16.16 0 0 1 .22-.012L42.84 43.505c.065.054.07.147.013.208a.16.16 0 0 1-.116.05M12.443 10.674a.15.15 0 0 1-.156-.147c0-.082.07-.148.156-.148l24.722-.004c.086 0 .156.066.156.148s-.07.147-.156.147zM12.443 17.494a.15.15 0 0 1-.156-.147c0-.082.07-.148.156-.148l24.722-.004c.086 0 .156.066.156.148s-.07.148-.156.148zM12.445 24.315a.15.15 0 0 1-.156-.148c0-.082.07-.147.156-.147l24.722-.004c.086 0 .156.066.156.147 0 .082-.07.148-.156.148z"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "mail-successes_Illustration_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
    ]
  }
);
var MailSuccessesIllustration_default = MailSuccessesIllustration;

export {
  MailSuccessesIllustration,
  MailSuccessesIllustration_default
};
